import React, {useCallback} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import $ from "jquery";
import {FormattedMessage, injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import {checkIfFeatureDisabled, navFeatureCLick} from "../lookFunctions";
import {updateCanvasCount} from "../../../../actions/actionFunctions";
import {featureInterface} from "../../../../interfaces/featureInterface";
import {disableFeature, enableRelatedFeature} from "../lookFunctions2";
import {setLookOverlayOpened, setLookStylePopup} from "../../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../../core/constants";
import {IS_LIXIL_UI, IS_PRODUCT_JOURNEY, IS_QKB_UI} from "../../../../config";

import {getCurrentLayout} from "../../../appLayout";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {getFeatureIsLocked} from "../../../../misc/helpers";
import WithUpdateLookCartItem from "../../hocs/withUpdateLookCartItem";
import ActionTypes from "../../../../misc/actionTypes";

const LookFeatureRemoveButton = (props) => {

  const {lookFeature, updateCanvasCount, isIcon, isList, isToggle, intl, setLookOverlayOpened, setLookStylePopup,
    text, updateLookCartItem, refreshItems} = props;

  const parent = lookFeature.getParent();
  const alreadyDisabled = checkIfFeatureDisabled(lookFeature, parent);
  const featureIsLocked = getFeatureIsLocked(lookFeature);

  const updateForOldUI = useCallback(() => {
    if (!IS_QKB_UI) {
      return
    }
    $(window).trigger(ActionTypes.CHANGE_LAYOUT); // update canvas
    if (refreshItems) {
      refreshItems();// update navigation (non compatible)
    }
  }, [refreshItems]);

  const deleteButtonClick = async () => {
    if (alreadyDisabled) {
      return false
    }

    if (IS_LIXIL_UI) {
      const featureLabel = Analytics.getSkuForAnalytics(lookFeature);
      Analytics.sendClickEvent(IS_PRODUCT_JOURNEY
        ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureRemove + featureLabel
        : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureRemove + featureLabel
      );

      if (featureIsLocked) {
        setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
        return false
      }
    }

    const layout = getCurrentLayout();
    if (document.kvConfig.visualizerType === "bvLook") {
      switch (lookFeature.partId) {
        case "vanity_faucet":
        case "vanity_sink": {
          if (IS_PRODUCT_JOURNEY) {
            if (lookFeature.partId === "vanity_sink") {
              const relatedFeatureGroup = layout.getFeatureGroupByPartId("vanity_faucet");
              if (relatedFeatureGroup && !relatedFeatureGroup.disabled && relatedFeatureGroup.activeFeature
                && (!relatedFeatureGroup.activeFeature.metaData["MountType"] || !relatedFeatureGroup.activeFeature.metaData["MountType"].includes('U'))) {
                // Turning off the faucet should not turn off the sink or countertop, but turning of the sink should turn off the faucet (*unless it’s a wall mount faucet)
                disableFeature(relatedFeatureGroup.activeFeature, updateLookCartItem);
              }
            }
            break;
          }
          const parent = layout.getSubPartByPartId(lookFeature.partId === "vanity_faucet" ? "vanity_sink" : "vanity_faucet");
          if (IS_LIXIL_UI && parent && lookFeature.metaData["layerPosition"] && parent.part.layerPositions[lookFeature.metaData.layerPosition]) {
            setLookOverlayOpened(LOOK_OVERLAYS.styleRemoveFeature);
            // setLookRemovePopup({
            //   fromFeature: lookFeature
            // });
            setLookStylePopup({
              notMatchingFeatures: [parent.part.layerPositions[lookFeature.metaData.layerPosition]]
            });
            return false
          }
          break;
        }
        case "toilet": {
          ["toilet_brush", "paper_holder"].forEach(partId => {
            const relatedFeatureGroup = layout.getFeatureGroupByPartId(partId);
            if (relatedFeatureGroup && !relatedFeatureGroup.disabled && relatedFeatureGroup.activeFeature) {
              disableFeature(relatedFeatureGroup.activeFeature, updateLookCartItem);
            }
          })
          break;
        }
        default:
          break;
      }
    }

    await disableFeature(lookFeature, updateLookCartItem);
    updateCanvasCount(); // update canvas and self component
    updateForOldUI(); // update canvas with jquery ommmg
  };

  const turnOnClick = () => {
    const featureLabel = Analytics.getSkuForAnalytics(lookFeature);
    Analytics.sendClickEvent(IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureEnable + featureLabel
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureEnable + featureLabel
    );

    if (parent.disabled) {
      parent.disabled = false;
      parent.disabledClick();
    }
    navFeatureCLick(lookFeature);
    enableRelatedFeature(lookFeature, null, null);
    updateCanvasCount(); // update canvas and self component
    updateForOldUI(); // update canvas with jquery ommmg
  }

  if (isIcon) {
    return (
      <IconButton aria-label={intl.formatMessage({id:"iconButton.delete"})}
                  className={isList ? "look-icon look-icon--delete" : "look-icon look-icon--small look-icon--white2"}
                  disabled={alreadyDisabled || !parent.canBeDisabled}
                  onClick={deleteButtonClick}>
        <DeleteForeverIcon/>
      </IconButton>
    )
  }

  if (isToggle) {
    return (
      <FormControlLabel
        control={
          <Switch
            className="gm-ios-checkbox"
            // classes={{
            //   switchBase: "switchBase",
            //   bar: "bar",
            //   icon: "icon",
            //   iconChecked: "iconChecked",
            //   checked: "checked",
            // }}
            disabled={!parent.canBeDisabled}
            disableRipple
            checked={!alreadyDisabled}
            onChange={alreadyDisabled ? turnOnClick : deleteButtonClick}
            color="primary"
          />
        }
        label={intl.formatMessage({id: text || "grohe.mobile.feature.enableButton"})}
      />
    )
  }

  return (
    <Button className={"look-button look-button--secondary look-button--max"}
            disabled={alreadyDisabled || !parent.canBeDisabled}
            startIcon={<DeleteIcon />}
            onClick={deleteButtonClick}>
      <FormattedMessage id="look.feature.removeButton"/>
    </Button>
  )
};

LookFeatureRemoveButton.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
  updateLookCartItem: PropTypes.func.isRequired,
  isList: PropTypes.bool,
  isIcon: PropTypes.bool,
  isToggle: PropTypes.bool,
  text: PropTypes.string,
}

const mapStateToProps = (store) => {
  const {canvasCount} = store.bathroomVisualizerState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in

  return {
    canvasCount,
    isPhoneNumberValidated,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  // setLookRemovePopup,
  setLookStylePopup,
  updateCanvasCount,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)((props) => {
    return (
      <WithUpdateLookCartItem>
        {(updateLookCartItem) => <LookFeatureRemoveButton {...props} updateLookCartItem={updateLookCartItem}/>}
      </WithUpdateLookCartItem>
    )
  })
)
